/* ============================================================================
   JuiceBox Super Summer Sale 2026 — behavior for snippets/jb-super-summer-sale.liquid
   Modules: phase machine + countdown, cart-aware tier ladder, filter/sort.
   The initial page state is server-rendered; everything here only keeps it
   live (cached pages self-correct on load, phase flips without reload).
   ========================================================================== */
(function () {
  var root = document.querySelector('.jb-sss');
  if (!root) return;

  /* ==================== Phase machine + countdown ==================== */
  var startMs = parseInt(root.getAttribute('data-sss-start'), 10) * 1000;
  var endMs = parseInt(root.getAttribute('data-sss-end'), 10) * 1000;
  var countEl = root.querySelector('[data-sss-countdown]');
  // NodeLists: the hero countdown and its compact mirror in the sticky
  // filter bar share the same data-sss-cd digits, fed by one tick.
  var digits = {
    d: root.querySelectorAll('[data-sss-cd="d"]'),
    h: root.querySelectorAll('[data-sss-cd="h"]'),
    m: root.querySelectorAll('[data-sss-cd="m"]'),
    s: root.querySelectorAll('[data-sss-cd="s"]')
  };
  var tickTimer = null;
  var lastAriaMinute = -1;

  function computePhase(now) {
    if (now < startMs) return 'before';
    if (now <= endMs) return 'live';
    return 'ended';
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function setDigit(key, value) {
    Array.prototype.forEach.call(digits[key], function (el) {
      if (el.textContent !== value) el.textContent = value;
    });
  }

  function tick() {
    var now = Date.now();
    var phase = computePhase(now);

    if (root.getAttribute('data-sss-phase') !== phase) {
      // CSS keyed off this attribute handles all show/hide — no reload needed.
      root.setAttribute('data-sss-phase', phase);
    }

    if (phase === 'ended') {
      if (tickTimer) {
        clearInterval(tickTimer);
        tickTimer = null;
      }
      return;
    }

    var target = phase === 'before' ? startMs : endMs;
    var diff = Math.max(0, Math.floor((target - now) / 1000));
    var d = Math.floor(diff / 86400);
    var h = Math.floor((diff % 86400) / 3600);
    var m = Math.floor((diff % 3600) / 60);
    var s = diff % 60;

    setDigit('d', pad(d));
    setDigit('h', pad(h));
    setDigit('m', pad(m));
    setDigit('s', pad(s));

    // Refresh the timer label at most once per minute (avoids SR spam).
    if (countEl && m !== lastAriaMinute) {
      lastAriaMinute = m;
      var verb = phase === 'before' ? 'bis zum Start' : 'bis zum Ende';
      countEl.setAttribute(
        'aria-label',
        'Noch ' + d + ' Tage, ' + h + ' Stunden und ' + m + ' Minuten ' + verb + ' des Sales'
      );
    }
  }

  tick();
  tickTimer = setInterval(tick, 1000);

  /* ==================== Cart-aware tier ladder ==================== */
  var ladder = root.querySelector('[data-sss-ladder]');
  if (ladder) {
    var jbId = parseInt(root.getAttribute('data-sss-jb-id'), 10);
    var threshold = parseInt(root.getAttribute('data-sss-tier-threshold'), 10) || 5;
    var tier2Label = root.getAttribute('data-sss-tier2') || '';
    var ladderFill = ladder.querySelector('[data-sss-ladder-fill]');
    var ladderMsg = ladder.querySelector('[data-sss-ladder-msg]');
    var ladderDots = ladder.querySelectorAll('[data-sss-dot]');
    var ladderTiers = ladder.querySelectorAll('[data-sss-tier]');

    var renderLadder = function (qty) {
      var clamped = Math.min(qty, threshold);
      if (ladderFill) {
        ladderFill.style.width = (clamped / threshold) * 100 + '%';
      }
      Array.prototype.forEach.call(ladderDots, function (dot) {
        var n = parseInt(dot.getAttribute('data-sss-dot'), 10);
        dot.classList.toggle('is-done', qty >= n);
      });
      Array.prototype.forEach.call(ladderTiers, function (tier) {
        var n = parseInt(tier.getAttribute('data-sss-tier'), 10);
        var active = qty > 0 && (n === 2 ? qty >= threshold : qty < threshold);
        tier.classList.toggle('is-active', active);
      });
      if (!ladderMsg) return;
      if (qty <= 0) {
        ladderMsg.hidden = true;
        ladderMsg.classList.remove('is-best');
      } else if (qty < threshold) {
        var missing = threshold - qty;
        ladderMsg.hidden = false;
        ladderMsg.classList.remove('is-best');
        ladderMsg.textContent =
          'Nur noch ' + missing + (missing === 1 ? ' Box' : ' Boxen') +
          ' bis zum Bestpreis von ' + tier2Label + ' pro Box!';
      } else {
        ladderMsg.hidden = false;
        ladderMsg.classList.add('is-best');
        ladderMsg.textContent =
          'Bestpreis aktiv! Du bekommst jede JuiceBox für ' + tier2Label + '.';
      }
    };

    var applyCart = function (cart) {
      if (!cart || !cart.items) return;
      var qty = 0;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].product_id === jbId) qty += cart.items[i].quantity;
      }
      renderLadder(qty);
    };

    var fetchCart = function () {
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(applyCart)
        .catch(function () { /* ladder stays in its static state; next cart:change self-heals */ });
    };

    // Impact theme contract: 'cart:change' bubbles from documentElement with
    // detail.cart = full /cart.js payload (fires on quick-adds AND drawer
    // line-item edits). 'cart:refresh' asks for a refetch.
    document.addEventListener('cart:change', function (e) {
      if (e.detail && e.detail.cart) applyCart(e.detail.cart);
    });
    document.addEventListener('cart:refresh', fetchCart);
    fetchCart();
  }

  /* ==================== Filter / sort engine ==================== */
  var chips = root.querySelectorAll('[data-sss-filter]');
  var bestToggle = root.querySelector('[data-sss-toggle="bestseller"]');
  var sortToggle = root.querySelector('[data-sss-sort="discount"]');
  var resetBtn = root.querySelector('[data-sss-reset]');
  var emptyEl = root.querySelector('[data-sss-empty]');
  var sections = root.querySelectorAll('[data-sss-sec]');
  var bar = root.querySelector('.jb-sss__bar');
  var ctaBtn = root.querySelector('[data-sss-cta]');
  var jbSec = root.querySelector('[data-sss-sec="juicebox"]');
  var moreWrap = root.querySelector('[data-sss-more-wrap]');
  var moreBtn = root.querySelector('[data-sss-more]');
  var jbLimit = moreBtn ? parseInt(moreBtn.getAttribute('data-sss-limit'), 10) || 8 : 8;

  var state = { cat: 'alle', bestseller: false, sortDiscount: false, jbExpanded: false };

  // Sold-out cards always sort behind available ones, whatever the order.
  function outRank(el) {
    return el.hasAttribute('data-soldout') ? 1 : 0;
  }

  function byOriginalIndex(a, b) {
    var out = outRank(a) - outRank(b);
    if (out !== 0) return out;
    return (
      parseInt(a.getAttribute('data-sss-idx'), 10) -
      parseInt(b.getAttribute('data-sss-idx'), 10)
    );
  }

  function byDiscountDesc(a, b) {
    var out = outRank(a) - outRank(b);
    if (out !== 0) return out;
    var diff =
      parseInt(b.getAttribute('data-discount'), 10) -
      parseInt(a.getAttribute('data-discount'), 10);
    return diff !== 0 ? diff : byOriginalIndex(a, b);
  }

  function apply() {
    // Chips filter on card-level categories (data-sss-cat); a category can
    // span sections (juicebox = JB grid + Genussbox cards in the deals grid).
    // Section visibility derives purely from "has >= 1 visible card".
    var filterActive = state.cat !== 'alle' || state.bestseller || state.sortDiscount;
    // The 8-card JuiceBox collapse only applies in the fully-default state,
    // so "first 8" is always the original Liquid order (sort auto-expands).
    var collapse = !!jbSec && !filterActive && !state.jbExpanded;
    var anyVisible = false;
    var truncating = false;

    // Round the collapse limit up to complete grid rows (2 cols on phones,
    // 5–6 on wide screens) so the collapsed grid never ends ragged.
    var effLimit = jbLimit;
    if (collapse) {
      var jbGrid = jbSec.querySelector('[data-sss-grid]');
      var cols = jbGrid ? getComputedStyle(jbGrid).gridTemplateColumns.split(' ').length : 1;
      if (cols > 1) effLimit = Math.ceil(jbLimit / cols) * cols;
    }

    Array.prototype.forEach.call(sections, function (sec) {
      var grid = sec.querySelector('[data-sss-grid]');
      var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-sss-card]')) : [];
      var order = cards.slice().sort(state.sortDiscount ? byDiscountDesc : byOriginalIndex);
      var visible = 0;

      // Re-appending moves the existing nodes (forms and their listeners stay
      // intact — the theme's custom elements listen on themselves/document).
      if (grid && cards.length > 1) {
        order.forEach(function (card) { grid.appendChild(card); });
      }

      order.forEach(function (card) {
        var hide =
          (state.cat !== 'alle' && card.getAttribute('data-sss-cat') !== state.cat) ||
          (state.bestseller && !card.hasAttribute('data-bestseller'));
        if (!hide && collapse && sec === jbSec && visible >= effLimit) {
          hide = true;
          truncating = true;
        }
        if (card.hidden !== hide) card.hidden = hide;
        if (!hide) visible++;
      });

      var hideSec = visible === 0;
      if (sec.hidden !== hideSec) sec.hidden = hideSec;
      if (!hideSec) anyVisible = true;
    });

    if (moreWrap) moreWrap.hidden = !truncating;
    if (emptyEl) emptyEl.hidden = anyVisible;

    Array.prototype.forEach.call(chips, function (chip) {
      chip.setAttribute('aria-pressed', chip.getAttribute('data-sss-filter') === state.cat ? 'true' : 'false');
    });
    if (bestToggle) bestToggle.setAttribute('aria-pressed', state.bestseller ? 'true' : 'false');
    if (sortToggle) sortToggle.setAttribute('aria-pressed', state.sortDiscount ? 'true' : 'false');
  }

  Array.prototype.forEach.call(chips, function (chip) {
    chip.addEventListener('click', function () {
      state.cat = chip.getAttribute('data-sss-filter');
      apply();
    });
  });
  if (bestToggle) {
    bestToggle.addEventListener('click', function () {
      state.bestseller = !state.bestseller;
      apply();
    });
  }
  if (sortToggle) {
    sortToggle.addEventListener('click', function () {
      state.sortDiscount = !state.sortDiscount;
      apply();
    });
  }
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      // jbExpanded is a disclosure preference, not a filter — keep it.
      state.cat = 'alle';
      state.bestseller = false;
      state.sortDiscount = false;
      apply();
    });
  }

  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      state.jbExpanded = true;
      apply();
      // Keyboard users: continue where the grid just grew.
      var revealed = jbSec && jbSec.querySelectorAll('[data-sss-card]')[jbLimit];
      var link = revealed && revealed.querySelector('.jb-sss__card-title a');
      if (link) link.focus();
    });
  }

  /* ==================== Hero CTA scroll ==================== */
  if (ctaBtn) {
    ctaBtn.addEventListener('click', function () {
      // Measure the sticky bar now — its height varies with viewport — and
      // hand it to the sections' scroll-margin-top via a custom property.
      if (bar) root.style.setProperty('--sss-bar-h', bar.offsetHeight + 'px');
      var target = null;
      for (var i = 0; i < sections.length; i++) {
        if (!sections[i].hidden) {
          target = sections[i];
          break;
        }
      }
      if (!target) target = bar || root;

      // Native smooth scrollIntoView gets canceled by the theme's rotating
      // announcement-bar carousel (its own scroll calls abort in-flight
      // smooth window scrolls), so we drive a short rAF animation instead.
      var offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      var destY = target.getBoundingClientRect().top + window.pageYOffset - offset;
      destY = Math.max(0, destY);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.scrollTo(0, destY);
        return;
      }
      var fromY = window.pageYOffset;
      var t0 = null;
      var DURATION = 500;
      var step = function (ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / DURATION);
        var eased = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
        window.scrollTo(0, fromY + (destY - fromY) * eased);
        if (p < 1) window.requestAnimationFrame(step);
      };
      window.requestAnimationFrame(step);
    });
  }

  // Initial pass: activates the JuiceBox collapse (SSR renders all cards so
  // no-JS users lose nothing) and unhides the show-more button.
  apply();

  // Grid column count changes with viewport width — refresh the row-aligned
  // collapse after resizes (debounced; apply() is cheap and idempotent).
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(apply, 150);
  });

  /* ==================== Before-phase teaser slider ==================== */
  // Arrow stepping over the announcement graphics in the "before" panel.
  // Element-level smooth scrollBy is safe here (own scroll box — the theme's
  // announcement carousel only cancels *window* scrolls, see the CTA above).
  var tease = root.querySelector('[data-sss-tease]');
  if (tease) {
    var teaseTrack = tease.querySelector('[data-sss-tease-track]');
    var teasePrev = tease.querySelector('[data-sss-tease-prev]');
    var teaseNext = tease.querySelector('[data-sss-tease-next]');
    var teaseReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    var teaseStep = function () {
      var slide = teaseTrack.querySelector('.jb-sss__tease-slide');
      if (!slide) return 300;
      var gap = parseFloat(getComputedStyle(teaseTrack).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    };

    // Arrow enabled/disabled state at the scroll ends. A hidden panel (other
    // phases) measures 0 → not scrollable → arrows stay hidden; scroll and
    // resize keep the state honest while the panel is visible.
    var teaseRefresh = function () {
      var max = teaseTrack.scrollWidth - teaseTrack.clientWidth;
      var scrollable = max > 1;
      teasePrev.hidden = !scrollable;
      teaseNext.hidden = !scrollable;
      teasePrev.disabled = teaseTrack.scrollLeft <= 1;
      teaseNext.disabled = teaseTrack.scrollLeft >= max - 1;
    };

    teasePrev.addEventListener('click', function () {
      teaseTrack.scrollBy({ left: -teaseStep(), behavior: teaseReduce.matches ? 'auto' : 'smooth' });
    });
    teaseNext.addEventListener('click', function () {
      teaseTrack.scrollBy({ left: teaseStep(), behavior: teaseReduce.matches ? 'auto' : 'smooth' });
    });
    teaseTrack.addEventListener('scroll', teaseRefresh, { passive: true });
    window.addEventListener('resize', teaseRefresh);
    teaseRefresh();
  }
})();
